module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5d21b51a41ba85b7852eb879dcc0ee30.png";